import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Susan Kalish · Art & Photography Portfolio</p>
        <h1>Discover the Beauty of Art and Photography</h1>
        <p className="lede">
          Explore the captivating works of Susan Kalish, where each piece tells a unique story through art and photography. Immerse yourself in a world of creativity and inspiration.
        </p>
        <div className="cta-row">
          <a href="#portfolio" className="primary">
            View Portfolio
          </a>
          <a href="#about" className="secondary">
            Learn More About Susan
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Artistic Vision</h2>
          <p>
            Experience a diverse range of artistic expressions that reflect Susan's unique perspective and passion for creativity.
          </p>
        </article>
        <article>
          <h2>Photography Excellence</h2>
          <p>
            Discover stunning photography that captures the essence of moments, emotions, and landscapes, showcasing Susan's talent behind the lens.
          </p>
        </article>
        <article>
          <h2>Connect with Creativity</h2>
          <p>
            Join a community of art lovers and enthusiasts. Stay updated with new works, exhibitions, and events featuring Susan's art and photography.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;